import script from "./PropertyVisitManagementsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./PropertyVisitManagementsList.vue?vue&type=script&lang=ts&setup=true"

import "./PropertyVisitManagementsList.vue?vue&type=style&index=0&id=d3bb046e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3bb046e"]])

export default __exports__